import { render, staticRenderFns } from "./AdminCategoryCreate.vue?vue&type=template&id=0cf4a15b"
import script from "./AdminCategoryCreate.vue?vue&type=script&lang=js"
export * from "./AdminCategoryCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports